import { FC } from 'react';
import operatorMenuItems from 'utils/config/operatorMenuItems';
import HeaderBase from './HeaderBase';

const HeaderOperator: FC = () => {
  return <HeaderBase menuItems={operatorMenuItems} />;
};

export default HeaderOperator;
